import { Route, Routes } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './middleware/ProtectedRoute';
import Login from './component/Login';
import AdminDashboard from './component/Admin/AdminDashboard';
import AllOrgsUsers from './component/Admin/AllOrgUsers';
import CreateUser from './component/Admin/CreateUser';
import SuperadminDashboard from './component/Superadmin/SuperadminDashboard';
import AllOrgs from './component/Superadmin/AllOrgs';
import CreateOrg from './component/Superadmin/CreateOrg';
import EditOrg from './component/Superadmin/EditOrg';
import EditAdmin from './component/Superadmin/EditAdmin';
import OrgDetails from './component/Admin/OrgDetails';
import UserDashboard from './component/Users/UserDashboard';
import Dashboard from './component/Users/Dashboard';
import SRACreation from './component/Users/Buyer/SRACreation/SRACreation';
import ViewSRA from './component/Users/ViewSRA';
import SRAUpdate from './component/Users/Buyer/SRAUpdate/SRAUpdate';
import ForgotPassword from './component/ForgotPassword';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
  const wheelHandler = (e) => {
    if (document.activeElement.matches('input[type=number]')) {
      e.preventDefault();
    }
  };

  const keyHandler = (e) => {
    if (
      document.activeElement.matches('input[type=number]') &&
      (e.key === "ArrowUp" || e.key === "ArrowDown")
    ) {
      e.preventDefault();
    }
  };

  window.addEventListener("wheel", wheelHandler, { passive: false });
  window.addEventListener("keydown", keyHandler);

  return () => {
    window.removeEventListener("wheel", wheelHandler);
    window.removeEventListener("keydown", keyHandler);
  };
}, []);
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user-onboarding" element={<ForgotPassword />} />
        <Route element={<ProtectedRoute allowedRoles={["SUPERADMIN"]} />}>
          <Route path="/superadmin-dashboard" element={<SuperadminDashboard />}>
            <Route path="/superadmin-dashboard" element={<AllOrgs />} />
            <Route path="/superadmin-dashboard/create-org" element={<CreateOrg />} />
            <Route path="/superadmin-dashboard/:orgId" element={<EditOrg />} />
            <Route path="/superadmin-dashboard/:orgId/admin" element={<EditAdmin />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path="/admin/org-details" element={<OrgDetails />} />
            <Route path="/admin" element={<AllOrgsUsers />} />
            <Route path="/admin/create-user" element={<CreateUser />} />
            <Route path="/admin/:orgUserId" element={<CreateUser />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["BUYER", "PURCHASE_HEAD", "TECHNICAL_HEAD", "FINANCE_HEAD", "TECHNICAL_MANAGER", "FINANCE_MANAGER", 'COO', 'CFO', 'CEO', 'CMD']} />}>
          <Route path="/dashboard" element={<UserDashboard />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/create-sra" element={<SRACreation />} />
            <Route path="/dashboard/create-sra/draft/:draftSraId" element={<SRACreation />} />
            <Route path="/dashboard/edit-sra/:sraId" element={<SRAUpdate />} />
            <Route path="/dashboard/:sraId" element={<ViewSRA />} />
          </Route>
        </Route>
        </Routes>
    </div>
  );
}

export default App;
